import { Linking, Alert } from 'react-native'
import InAppBrowser from 'react-native-inappbrowser-reborn'

import { normalizeURL } from './urls'

export const openLink = async (inputURL, useSystemBrowser = false) => {
  const url = normalizeURL(inputURL)

  try {
    if (
      (await InAppBrowser.isAvailable()) &&
      url &&
      url.match(/^https?:\/\//) &&
      !useSystemBrowser
    ) {
      await InAppBrowser.open(url, {
        dismissButtonStyle: 'done',
      })
    } else {
      await Linking.openURL(url)
    }
  } catch (err) {
    console.log('-------------> ERROR:', err)

    Alert.alert('Could not load link', url, [{ text: 'OK', onPress: () => {} }])
  }
}
